<script>
export default {
  name: 'SearchResultCard',
  props: ['result', 'displayProperties', 'imageType', 'imageRatio']
}
</script>

<template>
  <a class="kb-general-search__standard-result" :href="result.url">
    <div class="kb-general-search__result-content">

      <div class="kb-general-search__result-content-text">
        <template v-if="displayProperties.date && result.date">
          <p class="kb-general-search__result-date">{{ result.date }}</p>
        </template>
        <template v-if="displayProperties.breadcrumbs">
          <div class="kb-general-search__breadcrumb-display">
            <template v-for="(crumb, crumbindex) in result.breadcrumb" :key="crumbindex">
              <span>{{ crumb }}<div role="presentation" class="kb-ui-icon kb-ui-icon--ui-chevron-down"></div></span>
            </template>
          </div>
        </template>
        <template v-if="displayProperties.showCardTitle">
          <h2 class="kb-general-search__result-title" v-html="result.title"></h2>
        </template>
        <template v-if="displayProperties.summary">
          <template v-if="displayProperties.summary.hidable">
            <p class="kb-general-search__result-summary--hidable">{{ result.summary }}</p>
          </template>
          <template v-else>
            <p class="kb-general-search__result-summary">{{ result.summary }}</p>
          </template>
        </template>
        <template v-if="result.tags && result.tags.length">
          <ul class="kb-general-search__tags">
            <template v-for="(tag, tagindex) in result.tags" :key="tagindex">
              <li>
                <span class="kb-general-search__tag">{{ tag.name }}</span>
              </li>
            </template>
          </ul>
        </template>
      </div>

      <template v-if="displayProperties.image && result.imageUrl">
        <div class="kb-general-search__result-content-image-container"
            :class="imageRatio ? `kb-general-search__result-content-image-container--${imageType}` : null">
          <div class="kb-general-search__result-content-image-type-wrapper">
            <div class="kb-general-search__result-content-image" 
                :class="imageRatio ? `kb-general-search__result-content-image--${imageRatio}` : null">
              <img :src="result.imageUrl" alt="">
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="result.isExternalLink">
        <div class="kb-general-search__result-content-icon kb-ui-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
            <path fill="#E8001D" fill-rule="evenodd"
              d="m16.349 3.275-4.962-.246-.05-.999 5.462.27c.276.014.51.249.524.525l.27 5.462-.998-.05-.246-4.962ZM5.156 13.76l8.417-8.417.707.707-8.417 8.417-.707-.707ZM1.875 3.875h-.5v14.75h14.75v-8.234h-1v7.234H2.375V4.875h7.234v-1H1.875Z"
              clip-rule="evenodd" />
          </svg>
        </div>
      </template>
      <template v-else-if="result.isExternalLink">
        <div class="kb-general-search__result-content-icon kb-ui-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path fill="#E8001D" fill-rule="evenodd" d="m16.349 3.275-4.962-.246-.05-.999 5.462.27c.276.014.51.249.524.525l.27 5.462-.998-.05-.246-4.962ZM5.156 13.76l8.417-8.417.707.707-8.417 8.417-.707-.707ZM1.875 3.875h-.5v14.75h14.75v-8.234h-1v7.234H2.375V4.875h7.234v-1H1.875Z" clip-rule="evenodd"/></svg>
        </div>
      </template>
    </div>

</a></template>